<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'HeaderHome',
  props: {
    title: {
      type: String,
      default: '',
    },
    subTitle: {
      type: String,
      default: '',
    },
    userName: {
      type: String,
      default: '',
    },
    showModalLogout: {
      type: Function,
      default: () => null,
    },
  },
});
</script>

<template>
  <header class="flex justify-between p-10 pt-2 items-center text-white z-20">
    <div class="flex flex-col">
      <h1 class="font-normal text-1">{{ title }}</h1>
      <h2 class="font-bold text-1">{{ subTitle }}</h2>
    </div>

    <div
      class="rounded-r-full bg-blue-400 px-2 w-28 relative hover:cursor-pointer"
      :onclick="showModalLogout"
    >
      <div
        class="rounded-full flex justify-center bg-white w-9 h-9 hover:cursor-pointer icon_user_header"
        :onclick="showModalLogout"
      >
        <img src="@/assets/user.svg" class="w-5" />
      </div>
      <p class="pl-5 text-xs py-1">{{ userName }}</p>
    </div>
  </header>
</template>

<style lang="scss" scoped>
.icon_user_header {
  position: absolute;
  left: 0;
  bottom: -25%;
  transform: translate(-50%);
}
</style>
